export const matchPriority = (value) => {
  const priorities = [
    { value: '0', label: 'High' },
    { value: '1', label: 'Medium' },
    { value: '2', label: 'Low' }
  ];
  const element = priorities.find((elem) => elem.value === value);
  return element ? element.label : '';
};
